// extracted by mini-css-extract-plugin
export default {"wrapper":"UnderConstruction_wrapper__cqHR3","fade-in":"UnderConstruction_fade-in__+M+Hd","under-construction":"UnderConstruction_under-construction__N7umU"};